import styled from 'styled-components';

export const Wrapper = styled.div(
  props => `
    margin-top: 4rem;
`,
);

export const Title = styled.h2`
  font-size: 18px;
  font-family: 'Rubik';
  font-weight: 600;
`;

export const ContentWrapper = styled.div`
  background-color: rgb(255, 255, 255);
  border-radius: 12px;
  padding: 20px;
  margin-top: 2rem;
  ul {
    li {
      padding-bottom: 25px;

      &:last-child {
        padding-bottom: 8px;
      }
    }
  }
`;

export const ReviewWrapper = styled.div`
  display: flex;
  margin-top: 40px;
  &:first-child {
    margin-top: 0;
  }
`;

export const ImageWrapper = styled.div`
  margin-right: 16px;
`;

export const Image = styled.img`
  width: 30px;
  height: 30px;
  border-radius: 50%;
`;

export const Review = styled.div`
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const RatingReview = styled.div`
  display: flex;
  align-items: center;
  font-size: 1.2rem;
`;

export const ReviewCount = styled.div`
  margin-right: 0.5rem;
  color: #898b91;
`;

export const Ratings = styled.div`
  background-color: #1b9564;
  color: #fff;
  padding: 0.4rem 0.6rem;
  border-radius: 0.2rem;
`;

export const ReviewTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  font-family: 'Rubik';
  margin-right: 1rem;
`;

export const ReviewContent = styled.p`
  margin-top: 16px;
`;

export const ReviewSubContent = styled.div`
  display: flex;
  margin-top: 16px;
`;

export const ReviewLiked = styled.div`
  color: #2bac36;
`;

export const ReviewSub = styled.div`
  color: #4f525a;
`;

export const ViewMoreWrapper = styled.p`
  margin-top: 3rem;
  color: #2276e3;
`;

export const ReviewVehicle = styled.p`
  color: #4f525a;
  margin-top: 0.8rem;
`;
